/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteAutomationMutationResponse,
  DeleteAutomationPathParams,
} from '../types/DeleteAutomation'

function getDeleteAutomationUrl({
  id,
}: {
  id: DeleteAutomationPathParams['id']
}) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/automations/automations/${id}/` as const,
  }
  return res
}

/**
 * @description ViewSet for managing automations.
 * Provides CRUD operations for automations with different serializers
 * for list, detail, and create/update operations.
 * @summary Delete an automation
 * {@link /api/v1/automations/automations/:id/}
 */
export async function deleteAutomation(
  { id }: { id: DeleteAutomationPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteAutomationMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteAutomationUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
